<template>
    <div class="rental-link-list" v-if="rentals && rentals.length > 0">
        <div v-for="rental in rentals" :key="rental.id" class="rental-entry">
            <router-link :to="'/rental/view/projectId/' + rental.project_id + '/' + rental.id">
                {{ rental.rentalCompany.name }}
            </router-link>
            <br>
            <i>{{ rental.rentalCompany.address_1 }}</i>
            <rental-status :rental="rental"/>
        </div>
    </div>

</template>

<script>
export default {
    name: 'RentalLinkList',
    props: {
        rentals: Array,
    },
}
</script>

<style lang="scss">
.rental-entry {
    padding: 10px;
    border: solid 1px #ccc;
    margin: 10px 0;
}

</style>